import { useContext } from "react";
import { EventContext } from "./EventContext";

export function useEventEmitter() {
    return useContext(EventContext);
}
